import { render, staticRenderFns } from "./RankInfo.vue?vue&type=template&id=581da4f2&scoped=true&"
import script from "./RankInfo.vue?vue&type=script&lang=js&"
export * from "./RankInfo.vue?vue&type=script&lang=js&"
import style0 from "./RankInfo.vue?vue&type=style&index=0&id=581da4f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581da4f2",
  null
  
)

export default component.exports